import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleJobRate } from '../../../Store/PHPSlice/JobRate';
import { Edit, Preview } from '@mui/icons-material';


const TableBody = ({
    id,
    dt,
    itemNm,
    itemId,
    total,
    serialNumber,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();


    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Job Rate?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleJobRate(id))
                .then(() => {
                    // Reload the page to show updated results
                    alert("Job Rate Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };


    const handleViewClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/job-rate-view/${id}`, '_blank', 'width=800,height=400,scrollbars=yes,resizable=yes');
    };


    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/job-rate-edit/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{dt}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{itemNm}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{total}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Preview className="cursor-pointer" onClick={handleViewClick} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Edit className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>
            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
